import React from "react";

const Participant = ({ slide }) => {
  return (
    <div>
      <h1>Participant</h1>
      <h5>Slide: {slide}</h5>
    </div>
  );
};

export default Participant;
